import React from 'react';
import { PropsFromRedux } from '.';
import { useOverseasFormContext } from '../../../../context/OverseasShippingFormContext/context';
import { API_KEYS } from '../../../../interfaces/api';
import ModalWrapper from '../../../common/ModalWrapper';
import { Spinner } from '../../../Spinners/Spinner';

interface Props extends PropsFromRedux {}

const ShipmentMessage: React.FC<Props> = ({
  hideModal,
  getIntlShipmentMessage,
  shipmentMessage,
  resetApi,
}) => {
  const { loading, error, response } = shipmentMessage || {};
  const { formState } = useOverseasFormContext();

  const SenderCountry = formState?.supportingValues?.SenderCountry;

  React.useEffect(() => {
    getIntlShipmentMessage(SenderCountry.CountryId);
    return () => {
      resetApi(API_KEYS.GET_INTL_SHIPMENT_MESSAGE);
    };
  }, [SenderCountry.CountryId, getIntlShipmentMessage, resetApi]);

  React.useEffect(() => {
    if (error) {
      hideModal();
    }
  }, [error, hideModal]);

  if (loading) {
    return (
      <ModalWrapper hideCloseButton hideModal={hideModal}>
        <Spinner color="#CCC" />
      </ModalWrapper>
    );
  }

  return (
    <ModalWrapper hideModal={hideModal}>
      <div className="w-full max-w-sm text-center">
        <h2 className="text-3xl font-bold mb-10">Global Shipping</h2>
        <div
          className="mb-10"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: response?.Object?.Body || '' }}
        />
        <button
          type="button"
          onClick={() => hideModal()}
          className="mb-5 text-white bg-secondary font-bold py-3 w-full max-w-xs rounded"
        >
          Proceed
        </button>
      </div>
    </ModalWrapper>
  );
};

export default ShipmentMessage;
